import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/all-jobs-filter.svg'
import _imports_1 from '@/assets/icons/premium-filter.svg'
import _imports_2 from '@/assets/icons/Commercial.svg'
import _imports_3 from '../../../assets/icons/filter-icon.svg'
import _imports_4 from '../../../assets/images/property-owner-dashboard.png'
import _imports_5 from '@/assets/icons/premium-bg-white.svg'
import _imports_6 from '@/assets/icons/free-member-bg-white.svg'


const _withScopeId = n => (_pushScopeId("data-v-47ebb5e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "desktop__wrapper tw-mt-6" }
const _hoisted_2 = { class: "lg:tw-hidden tw-flex tw-justify-between tw-items-center" }
const _hoisted_3 = { class: "tw-flex tw-gap-[8px] tw-w-full tw-mb-2" }
const _hoisted_4 = { class: "tw-flex tw-gap-2 tw-justify-end tw-items-center" }
const _hoisted_5 = { class: "sort__wrapper desktop__wrapper" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "lg:tw-hidden tw-flex tw-gap-2 tw-w-full" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  src: _imports_0
}
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  src: _imports_1
}
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 1,
  src: _imports_2
}
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "mobile__wrapper tw-hidden lg:tw-block mobile__filter tw-mt-6" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "All Filters", -1))
const _hoisted_20 = { class: "mobile__inputs" }
const _hoisted_21 = { class: "tw-flex tw-gap-[8px] tw-w-full tw-mb-2" }
const _hoisted_22 = { class: "tw-flex tw-gap-2 tw-w-full tw-flex-col" }
const _hoisted_23 = ["src"]
const _hoisted_24 = {
  key: 1,
  src: _imports_0
}
const _hoisted_25 = ["src"]
const _hoisted_26 = ["src"]
const _hoisted_27 = {
  key: 1,
  src: _imports_1
}
const _hoisted_28 = ["src"]
const _hoisted_29 = ["src"]
const _hoisted_30 = {
  key: 1,
  src: _imports_2
}
const _hoisted_31 = ["src"]
const _hoisted_32 = {
  key: 0,
  class: "tw-flex tw-flex-col tw-justify-center tw-items-center tw-w-full tw-h-[calc(100dvh-221px)]"
}
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "tw-hidden lg:tw-flex tw-items-center tw-justify-between" }
const _hoisted_35 = { class: "sort__wrapper mobile__wrapper" }
const _hoisted_36 = ["src"]
const _hoisted_37 = { class: "tw-flex tw-gap-3 tw-mt-6 tw-mb-4 md:!tw-mt-0" }
const _hoisted_38 = { class: "tw-text-xs tw-font-normal tw-text-[#0C0F4A80] tw-tracking-[0.4px] tw-leading-4" }
const _hoisted_39 = {
  key: 0,
  class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-9 md:tw-mb-3 md:tw-gap-4"
}
const _hoisted_40 = /*#__PURE__*/_createStaticVNode("<div class=\"tw-flex tw-flex-col\" data-v-47ebb5e8><img width=\"340\" height=\"168\" src=\"" + _imports_4 + "\" data-v-47ebb5e8></div><div class=\"title\" data-v-47ebb5e8><h3 class=\"tw-mb-6 tw-text-2xl tw-text-[#0C0F4A] tw-leading-[30.12px] tw-tracking-[0.25px] tw-font-normal\" data-v-47ebb5e8> Find your next job, simply and easily. </h3><p class=\"tw-text-sm tw-text-[#0C0F4A80] tw-leading-[17.57px] tw-tracking-[0.15px] tw-font-medium\" data-v-47ebb5e8> Change your radius or add services to find more jobs. </p></div>", 2)
const _hoisted_42 = [
  _hoisted_40
]
const _hoisted_43 = { class: "text-left tw-w-[393px]" }
const _hoisted_44 = { class: "text-left tw-w-[130px]" }
const _hoisted_45 = { class: "text-left tw-w-[130px]" }
const _hoisted_46 = { class: "tw-flex tw-gap-2 tw-items-center" }
const _hoisted_47 = { class: "text-left tw-w-[130px]" }
const _hoisted_48 = { class: "text-left tw-w-[130px]" }
const _hoisted_49 = { class: "text-left tw-w-[120px]" }
const _hoisted_50 = { class: "text-left" }
const _hoisted_51 = { class: "tw-w-full tw-max-w-[340px] tw-flex tw-items-center tw-justify-start" }
const _hoisted_52 = { class: "text-left" }
const _hoisted_53 = { class: "text-left" }
const _hoisted_54 = { class: "tw-h-[24px] tw-bg-[#fff] tw-px-2 tw-rounded-md tw-border-solid tw-border-[1px] tw-border-[rgba(12,15,74,0.1)] tw-flex tw-gap-2 tw-items-center tw-justify-center" }
const _hoisted_55 = { class: "tag tw-rounded-full tw-flex tw-items-center tw-justify-center tw-w-[18px] tw-h-[18px]" }
const _hoisted_56 = {
  key: 0,
  class: "tw-w-[16px] tw-h-[16px] tw-object-contain",
  src: _imports_5
}
const _hoisted_57 = {
  key: 1,
  class: "tw-w-[16px] tw-h-[16px] tw-object-contain",
  src: _imports_6
}
const _hoisted_58 = { class: "text-left" }
const _hoisted_59 = { class: "text-left" }
const _hoisted_60 = { class: "text-left" }
const _hoisted_61 = {
  key: 2,
  class: "mobile-job-container scroll-container tw-gap-4 rmd:!tw-hidden"
}
const _hoisted_62 = { class: "tw-w-full tw-flex tw-items-start tw-justify-between tw-gap-2" }
const _hoisted_63 = { class: "tw-flex tw-gap-1 tw-flex-col tw-items-start tw-w-[66%]" }
const _hoisted_64 = { class: "tw-h-[24px] tw-bg-[#fff] tw-px-2 tw-rounded-md tw-border-solid tw-border-[1px] tw-border-[rgba(12,15,74,0.1)] tw-flex tw-gap-2 tw-items-center tw-justify-center" }
const _hoisted_65 = { class: "tag tw-rounded-full tw-flex tw-items-center tw-justify-center tw-w-[18px] tw-h-[18px]" }
const _hoisted_66 = {
  key: 0,
  class: "tw-w-[16px] tw-h-[16px] tw-object-contain",
  src: _imports_5
}
const _hoisted_67 = {
  key: 1,
  class: "tw-w-[16px] tw-h-[16px] tw-object-contain",
  src: _imports_6
}
const _hoisted_68 = { class: "tw-w-full tw-flex tw-items-center tw-gap-3" }
const _hoisted_69 = { class: "tw-flex tw-gap-1 tw-flex-col tw-items-start tw-w-[50%]" }
const _hoisted_70 = { class: "tw-flex tw-gap-1 tw-flex-col tw-items-start tw-w-[50%]" }
const _hoisted_71 = { class: "tw-w-full tw-flex tw-items-center tw-gap-3" }
const _hoisted_72 = { class: "tw-flex tw-gap-1 tw-flex-col tw-items-start tw-w-[50%]" }
const _hoisted_73 = { class: "tw-w-full tw-flex tw-items-center tw-gap-3" }
const _hoisted_74 = { class: "tw-flex tw-gap-1 tw-flex-col tw-items-start" }
const _hoisted_75 = { class: "tw-w-full tw-flex tw-items-center tw-justify-start tw-pt-3 tw-border-t-dashed-custom" }
const _hoisted_76 = {
  key: 3,
  class: "tw-absolute tw-bottom-[150px] tw-left-1/2 tw-translate-1/2 md:!tw-left-[40%]"
}
const _hoisted_77 = {
  key: 0,
  class: "tw-w-[calc(50%-16px)] tw-max-w-full md:tw-w-full md:tw-relative md:z-0 tw-h-[620px]"
}

import { useRouter } from "vue-router";
import { useStore } from "vuex";

import JobCard from "./JobCard.vue";
import InputField from "@/core/components/common/InputField.vue";
import InputSelect from "@/core/components/common/InputSelect.vue";

import JobMap from "./JobMap.vue";
import { onMounted, reactive, ref, watch } from "vue";
import { JOB_DETAILS_ROUTE } from "../routes";
import { computed } from "vue";
import { JOBS_STORE } from "@/store/modules/jobs";
import { JobFilters, JobsState } from "@/core/models/jobs";
import debounce from "lodash/debounce";
import Loader from "@/core/components/common/Loader.vue";
import { USER_STORE } from "@/store/modules/user";
import {
  ProjectOwnerTypesEnum,
  ProjectTypesEnum,
  PropertyCategoryEnum,
} from "@/core/enums/ProjectsEnum";
import CommonLoader from "@/core/components/CommonLoader.vue";
import EmergencyChip from "@/core/uni-components/Chips/EmergencyChip.vue";
import StandardChip from "@/core/uni-components/Chips/StandardChip.vue";
import RoutineChip from "@/core/uni-components/Chips/RoutineChip.vue";
import CommercialChip from "@/core/uni-components/Chips/CommercialChip.vue";
import ResidentialChip from "@/core/uni-components/Chips/ResidentialChip.vue";
import VideoConsultationChip from "@/core/uni-components/Chips/VideoConsultationChip.vue";
import Text from "@/core/components/ui/general/Text.vue";


import { defineComponent } from "vue";
import PropertyMapModal from "@/modules/properties/components/Modals/PropertyMapModal.vue";

const __default__ = defineComponent({
  name: "DraftJobListView",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const router = useRouter();
const store = useStore();
const isLoadingMorePage = ref(false);
const selectedJob = ref("");
const toggledView = ref("tile");
const loading = ref(false);
const listOfCategories = ref([]) as any;

const selectedJobTypeIcon = ref(null) as any;
const selectedMemberIcon = ref(null) as any;
const selectedPropertyTypeIcon = ref(null) as any;

const jobsList = ref(null) as any;

const handleJobType = (selectedValue: any) => {
  const selected = jobTypes.value.find(
    (item: any) => item.value === selectedValue
  );
  selectedJobTypeIcon.value = selected ? selected.iconName : null;
};
const handleMemberStatus = (selectedValue: any) => {
  const selected = propertiesMembers.value.find(
    (item: any) => item.value === selectedValue
  );
  selectedMemberIcon.value = selected ? selected.iconName : null;
};
const handlePropertyType = (selectedValue: any) => {
  const selected = propertyTypeItems.value.find(
    (item: any) => item.value === selectedValue
  );
  selectedPropertyTypeIcon.value = selected ? selected.iconName : null;
};
const jobTypes = ref([
  {
    text: "All Jobs",
    value: null,
    iconName: "all-jobs-filter",
  },
  {
    text: "Emergency",
    value: ProjectTypesEnum.EMERGENCY,
    iconName: "emergency-filter",
  },
  {
    text: "Routine ",
    value: ProjectTypesEnum.ROUTINE,
    iconName: "routine-filter",
  },
  {
    text: "Standard",
    value: ProjectTypesEnum.STANDARD,
    iconName: "standard-filter",
  },

  {
    text: "Video Consultation",
    value: ProjectTypesEnum.VIDEO_CONSULTATION,
    iconName: "video-filter",
  },
]);

const propertyTypeItems = computed(() => {
  return [
    {
      text: "All",
      value: null,
      iconName: "all-jobs-filter",
    },
    {
      text: "Commercial",
      value: PropertyCategoryEnum.COMMERCIAL,
      iconName: "commercial-filter",
    },
    {
      text: "Residential",
      value: PropertyCategoryEnum.RESIDENTIAL,
      iconName: "residential-filter",
    },
  ];
});

const propertiesMembers = computed(() => {
  return [
    {
      text: "All",
      value: "",
      iconName: "all-jobs-filter",
    },
    {
      text: "Premium Property Member",
      value: ProjectOwnerTypesEnum.PREMIUM_PROPERTY_MEMBER,
      iconName: "premium-filter",
    },
    {
      text: "Free Property Member",
      value: ProjectOwnerTypesEnum.FREE_PROPERTY_MEMBER,
      iconName: "Commercial",
    },
    {
      text: "External Clients",
      value: ProjectOwnerTypesEnum.EXTERNAL_CLIENTS,
      iconName: "Commercial",
    },
  ];
});
const user = computed(() => store.getters[`${USER_STORE}/user`]);

const jobsState = computed<JobsState["jobs"]>(() =>
  store.getters[`${JOBS_STORE}/getDraftJobs`]
    .map((job: any) => ({
      ...job,
      properties: job.projectProperties
        ?.filter((projProperty: any) => projProperty.property)
        ?.map((projProperty: any) => projProperty.property),
    }))
    .filter((property: any) => property)
);

const jobPropertyAddress = computed(() => {
  let address: any = [];

  jobsState.value.forEach((job: any) => {
    if (job?.projectProperties?.length) {
      job?.projectProperties?.forEach((item: any) => {
        address.push({ addressData: item?.property?.addressData });
      });
    }
  });
  return address;
});
const selectedCategory = ref([]);
const panel = ref([]);

const filters = reactive({
  search: "",
  postcode: "",
  radius: "",
  projectTypes: null,
  projectOwnerType: null,
  propertyCategory: null,
  specialism: [],
  order: "ASC",
  limit: 20,
  page: 1,
}) as any;

const prevPage = ref(filters.page);
const setSelectedJob = async (value: string) => {
  await store.dispatch(`${JOBS_STORE}/fetchJobDetails`, value);

  router.push({ name: JOB_DETAILS_ROUTE, params: { refId: value } });
  selectedJob.value = value;
};

const onClickToggleView = (value: string) => {
  toggledView.value = value;
};
const clearSelection = (field: any) => {
  filters[field] = null;
};
// FetchJobs
const refetchJobs = debounce(async (state: JobFilters) => {
  loading.value = true;
  try {
    await store.dispatch(`${JOBS_STORE}/fetchDraftJobs`, {
      ...state,
    });
  } finally {
    initializeJobsListings();
    loading.value = false;
  }
}, 500);

watch(
  filters,
  async (state: any) => {
    let params = JSON.parse(JSON.stringify({ ...state }));
    if (state.page == prevPage.value && state.page != 1) {
      state.page = 1;
    }
    prevPage.value = state.page;

    if (!params.specialism?.length) {
      delete params.specialism;
    } else {
      params.specialism = params.specialism.toString();
    }

    params = Object.fromEntries(
      Object.entries(params).filter((value: any) =>
        value[1] === 0 ? true : value[1]
      )
    );

    if (filters.page > 1) {
      await store.dispatch(`${JOBS_STORE}/fetchDraftJobs`, {
        ...params,
      });
      isLoadingMorePage.value = false;
    } else {
      refetchJobs(params);
    }
  },
  { deep: true }
);

const openSortButton = () => {
  panel.value = [];
};

const totalDraftPages = computed(
  () => store.getters[`${JOBS_STORE}/getTotalDraftPages`]
);

const totalDraftJobs = computed(
  () => store.getters[`${JOBS_STORE}/getTotalDraftJobs`]
);
const onScroll = (event: Event) => {
  const container = event.target as HTMLElement;
  const tolerance = 1;
  console.log("totalDraftPages " + totalDraftPages.value);
  if (
    Math.abs(
      container.scrollHeight - container.scrollTop - container.clientHeight
    ) <= tolerance
  ) {
    if (filters.page + 1 <= totalDraftPages.value) {
      isLoadingMorePage.value = true;
      setTimeout(() => {
        filters.page += 1;
      }, 1000);
    }
  }
};

const getPropertyCategory = (properties: any[] = []) => ({
  isResidential: properties.some(
    (property) =>
      property?.propertyCategory === PropertyCategoryEnum.RESIDENTIAL
  ),
  isCommercial: properties.some(
    (property) => property?.propertyCategory === PropertyCategoryEnum.COMMERCIAL
  ),
});

const calculateProperties = (properties: any[] = []) => {
  if (properties.length > 1) {
    return `${properties.length.toString()} Properties`;
  } else {
    return properties[0]?.postcode ?? "N/A"; // Return "N/A" if postcode is missing
  }
};

const initializeJobsListings = () => {
  jobsList.value = jobsState.value?.map((job: any) => ({
    ...job,
    location: calculateProperties(job?.properties),
    propertyType: getPropertyCategory(job?.properties || []), // Adding propertyType
  }));
};

onMounted(async () => {
  loading.value = true;

  listOfCategories.value = await store.dispatch(`${USER_STORE}/getCategories`);
  let postData = JSON.parse(JSON.stringify({ ...filters }));
  if (!postData.specialism?.length) {
    delete postData["specialism"];
  } else {
    postData.specialism = postData.specialism.toString();
  }
  postData = Object.fromEntries(
    Object.entries(postData).filter((value: any) =>
      value[1] === 0 ? true : value[1]
    )
  );

  // if (user.value.postcode) {
  //   postData.postcode = user.value.postcode;
  //   filters.postcode = user.value.postcode;
  // }

  try {
    await store.dispatch(`${JOBS_STORE}/fetchDraftJobs`, postData);
  } catch (error) {
    console.log();
  } finally {
    initializeJobsListings();
    loading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("main", { onScroll: onScroll }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(InputField, {
            "prepend-inner-icon": "mdi-magnify",
            class: "tw-max-w-[294px] c-input input_field",
            placeholder: "Search",
            modelValue: filters.search,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.search) = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(InputField, {
            "prepend-inner-icon": "mdi-map-marker",
            class: "tw-max-w-[143px] c-input input_field",
            placeholder: "KT19 9JG",
            modelValue: filters.postcode,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.postcode) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_btn_toggle, {
            modelValue: toggledView.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((toggledView).value = $event)),
            mandatory: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                "prepend-icon": "mdi-view-list",
                active: toggledView.value === 'tile',
                color: toggledView.value === 'tile' ? '#FAA100' : '',
                class: "tab__buttons",
                variant: "plain",
                value: "tile"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("List")
                ]),
                _: 1
              }, 8, ["active", "color"]),
              _createVNode(_component_v_btn, {
                "prepend-icon": "mdi-map",
                active: toggledView.value === 'map',
                color: toggledView.value === 'map' ? '#FAA100' : '',
                class: "tab__buttons",
                variant: "plain",
                value: "map"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Map")
                ]),
                _: 1
              }, 8, ["active", "color"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_v_menu, {
              persistent: true,
              "close-on-content-click": false,
              class: "desktop_sort_menu"
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_btn, _mergeProps(props, { variant: "plain" }), {
                  default: _withCtx(() => [
                    _createTextVNode(" Sort By "),
                    _createElementVNode("span", null, [
                      _createElementVNode("img", {
                        src: require('@/assets/icons/sort.svg'),
                        alt: ""
                      }, null, 8, _hoisted_6)
                    ])
                  ]),
                  _: 2
                }, 1040)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_radio_group, {
                  modelValue: filters.order,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.order) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_radio, {
                      label: "Most Recent",
                      value: "DESC",
                      color: "indigo"
                    }),
                    _createVNode(_component_v_radio, {
                      label: "Oldest",
                      value: "ASC",
                      color: "indigo"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_v_select, {
          class: "tw-max-w-full tw-w-1/4 custom-select input_field",
          placeholder: "All Jobs",
          items: jobTypes.value,
          "item-title": "text",
          "item-value": "value",
          modelValue: filters.projectTypes,
          "onUpdate:modelValue": [
            _cache[5] || (_cache[5] = ($event: any) => ((filters.projectTypes) = $event)),
            handleJobType
          ],
          clearable: "",
          variant: "outlined",
          "menu-props": { contentClass: 'c_select__dropdown' }
        }, {
          "prepend-inner": _withCtx(() => [
            (selectedJobTypeIcon.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "tw-w-[10px] tw-h-[10px]",
                  src: require(`@/assets/icons/${selectedJobTypeIcon.value}.svg`)
                }, null, 8, _hoisted_8))
              : (_openBlock(), _createElementBlock("img", _hoisted_9))
          ]),
          item: _withCtx(({ props, item }) => [
            _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
              default: _withCtx(() => [
                (item.raw.iconName)
                  ? (_openBlock(), _createBlock(_component_v_icon, {
                      key: 0,
                      class: "list_content_btn"
                    }, {
                      default: _withCtx(() => [
                        (item.raw.iconName)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: require('@/assets/icons/' + item.raw.iconName + '.svg'),
                              alt: "icon"
                            }, null, 8, _hoisted_10))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1040)
          ]),
          clear: _withCtx(() => [
            _createVNode(_component_v_btn, {
              text: "",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (clearSelection('projectTypes'))),
              class: "tw-text-blue-500 tw-underline tw-font-normal hover:tw-text-blue-700 tw-text-xs tw-tracking-[0.25px] tw-capitalize"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Clear ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["items", "modelValue"]),
        _createVNode(_component_v_select, {
          class: "tw-max-w-full tw-w-1/4 custom-select input_field",
          placeholder: "Premium Property Member",
          items: propertiesMembers.value,
          "item-title": "text",
          "item-value": "value",
          modelValue: filters.projectOwnerType,
          "onUpdate:modelValue": [
            _cache[7] || (_cache[7] = ($event: any) => ((filters.projectOwnerType) = $event)),
            handleMemberStatus
          ],
          clearable: "",
          variant: "outlined",
          "menu-props": { contentClass: 'c_select__dropdown' }
        }, {
          "prepend-inner": _withCtx(() => [
            (selectedMemberIcon.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "tw-w-[10px] tw-h-[10px]",
                  src: require(`@/assets/icons/${selectedMemberIcon.value}.svg`)
                }, null, 8, _hoisted_11))
              : (_openBlock(), _createElementBlock("img", _hoisted_12))
          ]),
          item: _withCtx(({ props, item }) => [
            _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
              default: _withCtx(() => [
                (item.raw.iconName)
                  ? (_openBlock(), _createBlock(_component_v_icon, {
                      key: 0,
                      class: "list_content_btn"
                    }, {
                      default: _withCtx(() => [
                        (item.raw.iconName)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: require('@/assets/icons/' + item.raw.iconName + '.svg'),
                              alt: "icon"
                            }, null, 8, _hoisted_13))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1040)
          ]),
          clear: _withCtx(() => [
            _createVNode(_component_v_btn, {
              text: "",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (clearSelection('projectOwnerType'))),
              class: "tw-text-blue-500 tw-underline tw-font-normal hover:tw-text-blue-700 tw-text-xs tw-tracking-[0.25px] tw-capitalize"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Clear ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["items", "modelValue"]),
        _createVNode(_component_v_select, {
          class: "tw-max-w-full tw-w-1/4 custom-select input_field",
          placeholder: "Commercial / Residential",
          "item-title": "text",
          "item-value": "value",
          items: propertyTypeItems.value,
          modelValue: filters.propertyCategory,
          "onUpdate:modelValue": [
            _cache[9] || (_cache[9] = ($event: any) => ((filters.propertyCategory) = $event)),
            handlePropertyType
          ],
          "menu-props": { contentClass: 'c_select__dropdown' },
          clearable: "",
          variant: "outlined"
        }, {
          "prepend-inner": _withCtx(() => [
            (selectedPropertyTypeIcon.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "tw-w-[10px] tw-h-[10px]",
                  src: require(`@/assets/icons/${selectedPropertyTypeIcon.value}.svg`)
                }, null, 8, _hoisted_14))
              : (_openBlock(), _createElementBlock("img", _hoisted_15))
          ]),
          item: _withCtx(({ props, item }) => [
            _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
              default: _withCtx(() => [
                (item.raw.iconName)
                  ? (_openBlock(), _createBlock(_component_v_icon, {
                      key: 0,
                      class: "list_content_btn"
                    }, {
                      default: _withCtx(() => [
                        (item.raw.iconName)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: require('@/assets/icons/' + item.raw.iconName + '.svg'),
                              alt: "icon"
                            }, null, 8, _hoisted_16))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1040)
          ]),
          clear: _withCtx(() => [
            _createVNode(_component_v_btn, {
              text: "",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (clearSelection('propertyCategory'))),
              class: "tw-text-blue-500 tw-underline tw-font-normal hover:tw-text-blue-700 tw-text-xs tw-tracking-[0.25px] tw-capitalize"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Clear ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["items", "modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_v_expansion_panels, {
        modelValue: panel.value,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((panel).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_expansion_panel, null, {
            title: _withCtx(() => [
              _hoisted_18,
              _hoisted_19
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_expansion_panel_text, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(InputField, {
                        "prepend-inner-icon": "mdi-magnify",
                        class: "tw-max-w-full tw-w-3/5 c-input input_field",
                        placeholder: "Search",
                        modelValue: filters.search,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((filters.search) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(InputField, {
                        "prepend-inner-icon": "mdi-map-marker",
                        class: "tw-max-w-full tw-w-1/5 c-input input_field",
                        placeholder: "KT19 9JG",
                        modelValue: filters.postcode,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((filters.postcode) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_v_select, {
                        class: "tw-max-w-full c-select input_field",
                        placeholder: "All Jobs",
                        items: jobTypes.value,
                        "item-title": "text",
                        "item-value": "value",
                        modelValue: filters.projectTypes,
                        "onUpdate:modelValue": [
                          _cache[13] || (_cache[13] = ($event: any) => ((filters.projectTypes) = $event)),
                          handleJobType
                        ],
                        clearable: "",
                        variant: "outlined",
                        "menu-props": { contentClass: 'c_select__dropdown' }
                      }, {
                        "prepend-inner": _withCtx(() => [
                          (selectedJobTypeIcon.value)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                class: "tw-w-[10px] tw-h-[10px]",
                                src: 
                        require(`@/assets/icons/${selectedJobTypeIcon.value}.svg`)
                      
                              }, null, 8, _hoisted_23))
                            : (_openBlock(), _createElementBlock("img", _hoisted_24))
                        ]),
                        item: _withCtx(({ props, item }) => [
                          _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                            default: _withCtx(() => [
                              (item.raw.iconName)
                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 0,
                                    class: "list_content_btn"
                                  }, {
                                    default: _withCtx(() => [
                                      (item.raw.iconName)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: 
                            require('@/assets/icons/' +
                              item.raw.iconName +
                              '.svg')
                          ,
                                            alt: "icon"
                                          }, null, 8, _hoisted_25))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1040)
                        ]),
                        clear: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            text: "",
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (clearSelection('projectTypes'))),
                            class: "tw-text-blue-500 tw-underline tw-font-normal hover:tw-text-blue-700 tw-text-xs tw-tracking-[0.25px] tw-capitalize"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Clear ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["items", "modelValue"]),
                      _createVNode(_component_v_select, {
                        class: "tw-max-w-full tw-w-1/4 custom-select input_field",
                        placeholder: "Premium Property Member",
                        items: propertiesMembers.value,
                        "item-title": "text",
                        "item-value": "value",
                        modelValue: filters.projectOwnerType,
                        "onUpdate:modelValue": [
                          _cache[15] || (_cache[15] = ($event: any) => ((filters.projectOwnerType) = $event)),
                          handleMemberStatus
                        ],
                        clearable: "",
                        variant: "outlined",
                        "menu-props": { contentClass: 'c_select__dropdown' }
                      }, {
                        "prepend-inner": _withCtx(() => [
                          (selectedMemberIcon.value)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                class: "tw-w-[10px] tw-h-[10px]",
                                src: require(`@/assets/icons/${selectedMemberIcon.value}.svg`)
                              }, null, 8, _hoisted_26))
                            : (_openBlock(), _createElementBlock("img", _hoisted_27))
                        ]),
                        item: _withCtx(({ props, item }) => [
                          _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                            default: _withCtx(() => [
                              (item.raw.iconName)
                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 0,
                                    class: "list_content_btn"
                                  }, {
                                    default: _withCtx(() => [
                                      (item.raw.iconName)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: 
                            require('@/assets/icons/' +
                              item.raw.iconName +
                              '.svg')
                          ,
                                            alt: "icon"
                                          }, null, 8, _hoisted_28))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1040)
                        ]),
                        clear: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            text: "",
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (clearSelection('projectOwnerType'))),
                            class: "tw-text-blue-500 tw-underline tw-font-normal hover:tw-text-blue-700 tw-text-xs tw-tracking-[0.25px] tw-capitalize"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Clear ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["items", "modelValue"]),
                      _createVNode(_component_v_select, {
                        "prepend-inner-icon": "mdi-account-hard-hat",
                        class: "tw-max-w-full c-select input_field",
                        placeholder: "Commercial / Residential",
                        "item-title": "text",
                        "item-value": "value",
                        items: propertyTypeItems.value,
                        modelValue: filters.propertyCategory,
                        "onUpdate:modelValue": [
                          _cache[17] || (_cache[17] = ($event: any) => ((filters.propertyCategory) = $event)),
                          handlePropertyType
                        ],
                        "menu-props": { contentClass: 'c_select__dropdown' },
                        clearable: "",
                        variant: "outlined"
                      }, {
                        "prepend-inner": _withCtx(() => [
                          (selectedPropertyTypeIcon.value)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                class: "tw-w-[10px] tw-h-[10px]",
                                src: 
                        require(`@/assets/icons/${selectedPropertyTypeIcon.value}.svg`)
                      
                              }, null, 8, _hoisted_29))
                            : (_openBlock(), _createElementBlock("img", _hoisted_30))
                        ]),
                        item: _withCtx(({ props, item }) => [
                          _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                            default: _withCtx(() => [
                              (item.raw.iconName)
                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 0,
                                    class: "list_content_btn"
                                  }, {
                                    default: _withCtx(() => [
                                      (item.raw.iconName)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: 
                            require('@/assets/icons/' +
                              item.raw.iconName +
                              '.svg')
                          ,
                                            alt: "icon"
                                          }, null, 8, _hoisted_31))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1040)
                        ]),
                        clear: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            text: "",
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (clearSelection('propertyCategory'))),
                            class: "tw-text-blue-500 tw-underline tw-font-normal hover:tw-text-blue-700 tw-text-xs tw-tracking-[0.25px] tw-capitalize"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Clear ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["items", "modelValue"])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", null, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
            _createVNode(Loader, { show: loading.value }, null, 8, ["show"])
          ]))
        : _createCommentVNode("", true),
      (!loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_v_btn_toggle, {
                modelValue: toggledView.value,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((toggledView).value = $event)),
                mandatory: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    "prepend-icon": "mdi-view-list",
                    active: toggledView.value === 'tile',
                    color: toggledView.value === 'tile' ? '#FAA10066' : '',
                    class: "tw-text-[12px]",
                    variant: "plain",
                    value: "tile",
                    onClick: _cache[19] || (_cache[19] = ($event: any) => (onClickToggleView('tile')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("List")
                    ]),
                    _: 1
                  }, 8, ["active", "color"]),
                  _createVNode(_component_v_btn, {
                    "prepend-icon": "mdi-map",
                    active: toggledView.value === 'map',
                    color: toggledView.value === 'map' ? '#FAA10066' : '',
                    class: "tw-text-[12px]",
                    variant: "plain",
                    value: "map",
                    onClick: _cache[20] || (_cache[20] = ($event: any) => (onClickToggleView('map')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Map")
                    ]),
                    _: 1
                  }, 8, ["active", "color"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_35, [
                _createVNode(_component_v_menu, {
                  persistent: true,
                  "close-on-content-click": false,
                  class: "mobile_sort_menu"
                }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_btn, _mergeProps(props, {
                      variant: "plain",
                      onClick: openSortButton,
                      menu: ""
                    }), {
                      default: _withCtx(() => [
                        _createTextVNode(" Sort By "),
                        _createElementVNode("span", null, [
                          _createElementVNode("img", {
                            src: require('@/assets/icons/sort.svg'),
                            alt: ""
                          }, null, 8, _hoisted_36)
                        ])
                      ]),
                      _: 2
                    }, 1040)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_radio_group, {
                      modelValue: filters.order,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((filters.order) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_radio, {
                          label: "Most Recent",
                          value: "DESC",
                          color: "indigo"
                        }),
                        _createVNode(_component_v_radio, {
                          label: "Oldest",
                          value: "ASC",
                          color: "indigo"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("p", _hoisted_38, [
                _createElementVNode("strong", null, _toDisplayString(totalDraftJobs.value), 1),
                _createTextVNode(" Results ")
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["tw-flex tw-gap-4 tw-overflow-y-auto tw-overflow-x-hidden no-scrollbar md:tw-max-h-[unset] working-2", 
            toggledView.value === 'map' && jobsState.value.length
              ? 'md:tw-px-0 md:tw-overflow-x-auto'
              : ''
          ])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["", 
              toggledView.value === 'tile' || !jobsState.value.length
                ? 'tw-w-full '
                : ' tw-w-1/2 md:tw-absolute md:tw-z-[999] md:tw-bottom-0 md:tw-w-full md:tw-max-w-full md:tw-h-auto md:tw-overflow-y-hidden md:tw-overflow-x-auto  md:tw-flex  md:tw-items-end working-1 tw-max-h-[620px] tw-overflow-auto no-scrollbar'
            ])
              }, [
                (!loading.value && !jobsState.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, _hoisted_42))
                  : _createCommentVNode("", true),
                (!loading.value && jobsState.value.length)
                  ? (_openBlock(), _createBlock(_component_v_table, {
                      key: 1,
                      class: "tw-bg-[#F8FBFD] tw-rounded-lg tw-border-solid tw-border-[1px] tw-border-[#DFDFDF] tw-w-full tw-hidden rmd:!tw-flex"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", _hoisted_43, [
                              _createVNode(Text, {
                                class: "!tw-text-[10.83px] !tw-uppercase",
                                whiteSpace: "nowrap"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Job Name")
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("th", _hoisted_44, [
                              _createVNode(Text, {
                                class: "!tw-text-[10.83px] !tw-uppercase",
                                whiteSpace: "nowrap"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Location")
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("th", _hoisted_45, [
                              _createElementVNode("div", _hoisted_46, [
                                _createVNode(Text, {
                                  class: "!tw-text-[10.83px] !tw-uppercase",
                                  whiteSpace: "nowrap"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Client")
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _createElementVNode("th", _hoisted_47, [
                              _createVNode(Text, {
                                class: "!tw-text-[10.83px] !tw-uppercase",
                                whiteSpace: "nowrap"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Job type")
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("th", _hoisted_48, [
                              _createVNode(Text, {
                                class: "!tw-text-[10.83px] !tw-uppercase",
                                whiteSpace: "nowrap"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Property Type")
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("th", _hoisted_49, [
                              _createVNode(Text, {
                                class: "!tw-text-[10.83px] !tw-uppercase",
                                whiteSpace: "nowrap"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Action")
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobsList.value, (job, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createElementVNode("td", _hoisted_50, [
                                _createElementVNode("div", _hoisted_51, [
                                  _createVNode(Text, {
                                    variant: "span",
                                    whiteSpace: "nowrap",
                                    textWeight: "500",
                                    class: "!tw-truncate"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(job?.name), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ])
                              ]),
                              _createElementVNode("td", _hoisted_52, [
                                _createVNode(Text, {
                                  variant: "span",
                                  whiteSpace: "nowrap",
                                  textWeight: "500"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(job?.location), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _createElementVNode("td", _hoisted_53, [
                                _createElementVNode("div", _hoisted_54, [
                                  _createElementVNode("div", _hoisted_55, [
                                    (job?.userWorkstation?.subscription)
                                      ? (_openBlock(), _createElementBlock("img", _hoisted_56))
                                      : (_openBlock(), _createElementBlock("img", _hoisted_57))
                                  ]),
                                  _createVNode(Text, {
                                    variant: "span",
                                    whiteSpace: "nowrap"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(job?.userWorkstation?.subscription
                            ? "PREMIUM"
                            : "FREE") + " ", 1),
                                      _createVNode(Text, {
                                        variant: "span",
                                        whiteSpace: "nowrap",
                                        textColor: "#FFA500"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("MEMBER")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1024)
                                ])
                              ]),
                              _createElementVNode("td", _hoisted_58, [
                                (job?.type === 'emergency')
                                  ? (_openBlock(), _createBlock(EmergencyChip, {
                                      key: 0,
                                      label: "Emergency",
                                      class: "!tw-w-[97px]"
                                    }))
                                  : _createCommentVNode("", true),
                                (job?.type === 'standard')
                                  ? (_openBlock(), _createBlock(StandardChip, {
                                      key: 1,
                                      class: "!tw-w-[90px]"
                                    }))
                                  : _createCommentVNode("", true),
                                (job?.type === 'routine')
                                  ? (_openBlock(), _createBlock(RoutineChip, {
                                      key: 2,
                                      class: "!tw-w-[80px]"
                                    }))
                                  : _createCommentVNode("", true),
                                (job?.type === 'video consultation')
                                  ? (_openBlock(), _createBlock(VideoConsultationChip, { key: 3 }))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("td", _hoisted_59, [
                                (job?.propertyType?.isResidential)
                                  ? (_openBlock(), _createBlock(ResidentialChip, {
                                      key: 0,
                                      class: "!tw-p-0"
                                    }))
                                  : _createCommentVNode("", true),
                                (job?.propertyType?.isCommercial)
                                  ? (_openBlock(), _createBlock(CommercialChip, {
                                      key: 1,
                                      class: "!tw-p-0"
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("td", _hoisted_60, [
                                _createVNode(Text, {
                                  onClick: ($event: any) => (setSelectedJob(job?.refId)),
                                  variant: "span",
                                  whiteSpace: "nowrap",
                                  textWeight: "500",
                                  textColor: "#4F55F0",
                                  class: "tw-cursor-pointer"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("View Details")
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ])
                            ]))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!loading.value && jobsState.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobsList.value, (job, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "tw-bg-[#F8FBFD] tw-w-full tw-rounded-lg tw-border-solid tw-border-[1px] tw-border-[#DFDFDF] tw-p-4 tw-box-border tw-flex tw-flex-col tw-gap-4"
                        }, [
                          _createElementVNode("div", _hoisted_62, [
                            _createElementVNode("div", _hoisted_63, [
                              _createVNode(Text, {
                                variant: "xsmall",
                                lineHeight: "18px"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("NAME")
                                ]),
                                _: 1
                              }),
                              _createVNode(Text, {
                                variant: "span",
                                textWeight: "400",
                                lineHeight: "18px",
                                textAlign: "left",
                                class: "!tw-truncate !tw-w-full"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(job?.name), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _createElementVNode("div", _hoisted_64, [
                              _createElementVNode("div", _hoisted_65, [
                                (job?.userWorkstation?.subscription)
                                  ? (_openBlock(), _createElementBlock("img", _hoisted_66))
                                  : (_openBlock(), _createElementBlock("img", _hoisted_67))
                              ]),
                              _createVNode(Text, {
                                variant: "span",
                                whiteSpace: "nowrap"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(job?.userWorkstation?.subscription ? "PREMIUM" : "FREE") + " ", 1),
                                  _createVNode(Text, {
                                    variant: "span",
                                    whiteSpace: "nowrap",
                                    textColor: "#FFA500"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("MEMBER")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_68, [
                            _createElementVNode("div", _hoisted_69, [
                              _createVNode(Text, {
                                variant: "xsmall",
                                lineHeight: "18px"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("LOCATION")
                                ]),
                                _: 1
                              }),
                              _createVNode(Text, {
                                variant: "span",
                                textWeight: "400",
                                lineHeight: "18px"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(job?.location), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _createElementVNode("div", _hoisted_70, [
                              _createVNode(Text, {
                                variant: "xsmall",
                                lineHeight: "18px"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("PROPERTY TYPE")
                                ]),
                                _: 1
                              }),
                              (job?.propertyType?.isResidential)
                                ? (_openBlock(), _createBlock(ResidentialChip, {
                                    key: 0,
                                    class: "!tw-p-0"
                                  }))
                                : _createCommentVNode("", true),
                              (job?.propertyType?.isCommercial)
                                ? (_openBlock(), _createBlock(CommercialChip, {
                                    key: 1,
                                    class: "!tw-p-0"
                                  }))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_71, [
                            _createElementVNode("div", _hoisted_72, [
                              _createVNode(Text, {
                                variant: "xsmall",
                                lineHeight: "18px"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("JOB TYPE")
                                ]),
                                _: 1
                              }),
                              (job?.type === 'emergency')
                                ? (_openBlock(), _createBlock(EmergencyChip, {
                                    key: 0,
                                    label: "Emergency",
                                    class: "!tw-w-[97px]"
                                  }))
                                : _createCommentVNode("", true),
                              (job?.type === 'standard')
                                ? (_openBlock(), _createBlock(StandardChip, {
                                    key: 1,
                                    class: "!tw-w-[90px]"
                                  }))
                                : _createCommentVNode("", true),
                              (job?.type === 'routine')
                                ? (_openBlock(), _createBlock(RoutineChip, {
                                    key: 2,
                                    class: "!tw-w-[80px]"
                                  }))
                                : _createCommentVNode("", true),
                              (job?.type === 'video consultation')
                                ? (_openBlock(), _createBlock(VideoConsultationChip, { key: 3 }))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_73, [
                            _createElementVNode("div", _hoisted_74, [
                              _createVNode(Text, {
                                variant: "xsmall",
                                lineHeight: "18px"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("ESTS. RECEIVED")
                                ]),
                                _: 1
                              }),
                              _createVNode(Text, {
                                variant: "span",
                                textWeight: "400",
                                lineHeight: "18px"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("0")
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_75, [
                            _createVNode(Text, {
                              onClick: ($event: any) => (setSelectedJob(job?.refId)),
                              variant: "span",
                              textWeight: "500",
                              textColor: "#4F55F0",
                              class: "!tw-underline !tw-cursor-pointer",
                              lineHeight: "18px"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("View Details")
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (isLoadingMorePage.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                      (isLoadingMorePage.value)
                        ? (_openBlock(), _createBlock(CommonLoader, {
                            key: 0,
                            loading: isLoadingMorePage.value,
                            class: "loader-container"
                          }, null, 8, ["loading"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ], 2),
              (toggledView.value === 'map' && jobsState.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                    _createVNode(PropertyMapModal, { properties: jobPropertyAddress.value }, null, 8, ["properties"])
                  ]))
                : _createCommentVNode("", true)
            ], 2)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 32))
}
}

})